
    import '/opt/buildhome/repo/packages/x/docs/spec/hybrid-ui-design.en-US.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/spec/hybrid-ui-design.en-US.md?type=demo')
};